import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByIds } from '../../';
import { HorizontalRevenueChart } from './';
import { useDashboardZoneRevenueChart, useProfile, useRouterStore } from '../../../hooks';
import { tI, tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const ZoneRevenue: React.FC = observer(() => {
    const data = useDashboardZoneRevenueChart();
    const routerStore = useRouterStore();
    const { isCompanyTypeIdMNOHost } = useProfile();
    const title = `${tP('Top Zones')} ${tI(isCompanyTypeIdMNOHost ? 'by Revenue' : 'by Cost/Revenue')}`;
    const goToZoneList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('ZonesList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToZoneList} href={`/zones`}>
            {title}
        </a>
    );
    const goToZone = (id: string): void => {
        routerStore.goTo('CountryList', { queryParams: { zoneId: id } });
    };

    return (
        <Catcher>
            <LoadingApiByIds idSpinners={['GET_REVENUE_ZONE_LIST']} />
            <div className={Styles.chart}>
                <HorizontalRevenueChart
                    sourceData={data}
                    title={title}
                    titleLink={titleLink()}
                    onSelectRow={goToZone}
                />
            </div>
        </Catcher>
    );
});
